import { apiCall } from "../services/service";
import { URL_MFA_ADMIN_RESET, URL_MFA_DISABLE, URL_MFA_SETUP_ENROLL,
         URL_MFA_SETUP_VALIDATE,
        URL_MFA_STATUS,
        URL_VERIFY_MFA } from "./URL";

export const mfaService = {
  /**
   * Get current MFA status for the user
   */
  async getStatus() {
    try {
      const response = await apiCall.get({ url: URL_MFA_STATUS });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.data?.error || 'Failed to get MFA status',
        code: error.status };
    }
  },

  /**
   * Start MFA enrollment - get QR code and manual entry key
   * forcedToken is used in the case where we want to start MFA enrollment during login flow before user has a valid access token (after password verification but before MFA verification) 
   */
  async enroll(forcedToken) {
    try {

      const response = await apiCall.post(
        { 
          url: URL_MFA_SETUP_ENROLL, 
          forcedToken: forcedToken 
        }
      );

      return { 
        success: true, 
        data: {
          qrCodeUri: response.data.qrCodeUri,
          manualEntryKey: response.data.manualEntryKey
        }
      };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.data?.error || 'Failed to start MFA enrollment',
        code: error.status };
    }
  },

  /**
   * Verify MFA enrollment with TOTP code
   */
  async validate(code, forcedToken) {
    try {

      const response = await apiCall.post(
        {
          url: URL_MFA_SETUP_VALIDATE,
          forcedToken: forcedToken,
          params: { code }
        }
      );

      return { 
        success: true, 
        data: {
          backupCodes: response.data.backupCodes
        }
      };
    } catch (error) {
      return { 
        success: false,
        error: error.response?.data?.error || error.data?.error || 'Invalid verification code',
        code: error.status };
    }
  },

  /**
   * Verify MFA during login flow
   */
  async verifyLogin(payload, tenantId) {
    try {
      const response = await apiCall.post({
                                    url: URL_VERIFY_MFA,
                                    params: payload,
                                    tenantId,
                                });
      return { 
        success: true, 
        data: {
            accessToken: response.data.accessToken,
            refreshToken: response.data.refreshToken,
        }
      };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.data?.error ||  'Invalid verification code',
        code: error.status };
    }
  },

  /**
   * Disable MFA with verification code or backup code
   */
  async disable(code) {
    try {
      const response = await apiCall.post({url: URL_MFA_DISABLE, params: {code}});
      return { 
        success: true, 
        message: response?.data?.message || 'MFA disabled successfully'
      };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.data?.error || 'Failed to disable MFA',
        code: error.status };
    }
  },

  /**
   * Reset MFA when user has lost access to MFA device
   */
  async resetUserMfa(userId) { 
    try {
      const response = await apiCall.post({url: `${URL_MFA_ADMIN_RESET}/${userId}` });
      return { 
        success: true, 
        message: response?.data?.message || 'MFA reset successfully'
      };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.data?.error || 'Failed to reset MFA',
        code: error.status 
      };
    }
  }
};
